import Collapse from 'bootstrap/js/dist/collapse';
import 'owl.carousel';

var Share = {
  facebook: function ( purl, ptitle, pimg, text ) {
    let url = 'http://www.facebook.com/sharer.php?s=100';
    url += '&u=' + encodeURIComponent( purl );
    return url;
  },
  twitter: function ( purl, ptitle ) {
    let url = 'http://twitter.com/share?';
    url += 'text=' + encodeURIComponent( ptitle );
    url += '&url=' + encodeURIComponent( purl );
    url += '&counturl=' + encodeURIComponent( purl );
    return url;
  },
  linkedin: function ( purl, ptitle ) {
    let url = 'https://www.linkedin.com/shareArticle?mini=true';
    url += '&title=' + encodeURIComponent( ptitle );
    url += '&url=' + encodeURIComponent( purl );
    return url;
  },
  mail: function ( purl, ptitle ) {
    let url = 'mailto:';
    url += '?subject=' + encodeURIComponent( ptitle );
    return url;
  },
  init() {
    $( '.js-share-facebook' ).each( function ( index, item ) {
      $( item ).attr( 'href', Share.facebook(
        $( item ).data( 'url' )
      ) );
    } );

    $( '.js-share-twitter' ).each( function ( index, item ) {
      $( item ).attr( 'href', Share.twitter(
        $( item ).data( 'url' ),
        $( item ).data( 'title' )
      ) );
    } );

    $( '.js-share-linkedin' ).each( function ( index, item ) {
      $( item ).attr( 'href', Share.linkedin(
        $( item ).data( 'url' ),
        $( item ).data( 'title' )
      ) );
    } );

    $( '.js-share-mail' ).each( function ( index, item ) {
      $( item ).attr( 'href', Share.mail(
        $( item ).data( 'url' ),
        $( item ).data( 'title' )
      ) );
    } );
  }
};

var header = {
  toggler: false,
  //cl: $( '.js-header' ),
  toggle() {
    let $cl = $( '.js-header' );
    let scrollTop = $( window ).scrollTop();
    if ( scrollTop > 64 && !this.toggler ) {
      $cl.addClass( 'scrolled' );
      this.toggler = true;
    } else if ( scrollTop <= 0 && this.toggler ) {
      $cl.removeClass( 'scrolled' );
      this.toggler = false;
    }
  },
  init() {
    this.toggle();
    $( window ).on( 'scroll', () => {
      this.toggle();
    } );
  }
};

var floatLabel = {
  $control: $( '.form-control, .form-select' ),
  input( _this ) {
    let $label = $( _this ).parents( '.form-group' ).find( 'label' );
    if ( $( _this ).val() === null || $( _this ).val() === '' ) {
      if ( $label.hasClass( 'active' ) ) {
        $label.removeClass( 'active' );
      }
    } else {
      if ( !$label.hasClass( 'active' ) ) {
        $label.addClass( 'active' );
      }
    }
  },
  init() {
    this.$control.each( ( index, item ) => this.input( item ) );

    let _this = this;
    this.$control.on( 'input', function () {
      _this.input( this );
    } );
  }
};

let selectPlaceholder = {
  $selects: $( '.form-select' ),
  placeColor: '#00497f',
  defaultColor: '#002540',
  check( el ) {
    let _this = this;
    if ( el ) {
      let select = $( el );
      if ( select.val() === '' || select.val() === null ) {
        select.css( 'color', _this.placeColor );
      } else {
        select.css( 'color', _this.defaultColor );
      }
    }
  },
  init() {
    let _this = this;
    _this.$selects.each( function () {
      _this.check( this );
    } );
    this.$selects.on( 'input', function () {
      _this.check( this );
    } );
  }
};

let menu = {
  toggler: false,
  el: document.getElementById( 'menu' ),
  init() {
    if ( !this.el ) return;

    let collapse = new Collapse( this.el, {
      toggle: false
    } );

    this.el.addEventListener( 'hide.bs.collapse', () => {
      this.toggler = false;
    } );
    this.el.addEventListener( 'show.bs.collapse', () => {
      this.toggler = true;
    } );

    $( window ).on( 'scroll', () => {
      if ( this.toggler ) collapse.hide();
    } );
  }
};

let autoFill = {
  $links: $( '.js-recrut-links a' ),

  $selects: {
    meaux: $( '.js-recrut-select-m' ),
    lieusaint: $( '.js-recrut-select-l' ),
  },

  $section: $( '.js-recrut-section' ),

  $titles: {
    meaux: $( '.js-recrut-title[data-pole="meaux"]' ),
    lieusaint: $( '.js-recrut-title[data-pole="lieusaint"]' )
  },

  init() {
    let _this = this;

    console.log(this.$titles);

    ['meaux', 'lieusaint'].forEach(function(it) {
      _this.$titles[it].each( ( index, item ) => _this.$selects[it].append(
        $( '<option></option>', {
          value: $( item ).text(),
          text: $( item ).text()
        } )
      ) );
    });


    _this.$links.on( 'click', function ( e ) {
      e.preventDefault();
      let $btn = $( this );
      let title = $btn.data( 'title' );
      let pole = $btn.data( 'pole' );
      let $tabs = $('.js-form-tab');

      if ( (title || title === 0) && (pole || pole === 0) ) {
        _this.$selects[pole].val( title );

        $( '.js-form-etude' ).prop( 'checked', false );
        $( '.js-form-etude[value="' + pole + '"]' ).prop( 'checked', true );

        $tabs.removeClass('active');
        $tabs.filter('#' + pole +'-tab').addClass('active');

      }

      $( 'html, body' ).animate( {
        scrollTop: _this.$section.offset().top
      }, 300 );

      return false;
    } );
  }
};

let sideWindow = {
  $window: $( '.js-side' ),
  $btn: $( '.js-side-btn' ),
  //$body: $('body'),
  init() {
    this.$btn.on( 'click', e => {
      e.preventDefault();
      this.$window.toggleClass( 'opened' );

      return false;
    } );

    $( document ).on( 'click', ( e ) => {
      if (
        !( ( $( e.target ).parents( '.side-window' ).length ) || ( $( e.target ).hasClass( 'side-window' ) ) )
        &&
        this.$window.hasClass( 'opened' )
      )
        this.$window.removeClass( 'opened' );

    } );

  }
};

var customFile = {
  init() {
    $( '.js-custom-file input' ).on( 'change', function () {
      let $this = $( this );
      let $parent = $this.parents( '.js-custom-file' );
      let $label = $parent.find( 'label' );

      $parent.addClass( 'selected' );
      $label.text( $this[ 0 ].files[ 0 ].name );
    } );
  }
};

var form = {
  $etudeInput: $('.js-form-etude[name="etude"]'),
  $tabs: $('.js-form-tab'),

  init() {
    let _this = this;
    this.$etudeInput.on('change', function() {
      _this.$tabs.removeClass('active');
      _this.$tabs.filter('#' + $(this).val() +'-tab').addClass('active');
    });
  }
};

$( window ).on( 'load', () => {
  selectPlaceholder.init();
  header.init();
  floatLabel.init();
  menu.init();
  sideWindow.init();
  customFile.init();
  form.init();
  Share.init();

  let owlImages = $( '.js-owl-images' );
  let owlNews = $( '.js-owl-news' );

  owlImages.owlCarousel( {
    loop: true,
    items: 1,
    nav: false,
    dots: true
  } );

  owlNews.owlCarousel( {
    loop: false,
    nav: false,
    dots: true,
    margin: 30,
    responsive: {
      0: {
        items: 1
      },
      720: {
        items: 2
      },
      950: {
        items: 3
      }
    },
    onInitialized() {
      autoFill.init();
    }
  } );


} );